import {XhrService} from "cronus-theme/default/global/ts/xhr.service";
import {getAllQuantityInputs} from "cronus-theme/default/global/js/quantitySpinner";
import {updateItemlistStickyOrderBarCount} from "cronus-theme/default/global/js/itemlistStickyOrderBar";
import {addErrorClass, addLoadingClass, removeLoadingClass} from "cronus-theme/default/global/js/utilities/updateClasses";
import {calculateForItemNo} from "./depositCosts";
import {replaceItemno} from "./replaceItemno";
import {FetchService} from "dc-services/fetch.service";
import {externalStock} from "./externalStock";

const SESSION_ID = document.body.dataset.sessionId;

function updateInputDirectorder(input){
    let InputValue = input.value;
    XhrService.generalAjaxCall('getDirectOrderItemListRender', {
        "sid": SESSION_ID,
        "item_list": [InputValue]
    }, 'POST', 'json').then(async response => {
        if (response) {
            removeLoadingClass(input.closest(".inputGroup"));
            const response_item_key = Object.keys(response);

            for (const item_no of response_item_key) {
                let itemElement = document.getElementById("activDirectOrder");
                if (itemElement) {
                    if (response[item_no].show) {
                        // Response key is the search term, use the resolved item no
                        const resolvedItemNo = response[item_no].item_no;
                        itemElement.dataset.itemno = resolvedItemNo;
                        hideDirectorderMessageMaximum();
                        hideDirectorderMessage();
                        if (response[item_no].image) {
                            itemElement.querySelector('.image img').setAttribute("src", response[item_no].image);
                        }
                        if (response[item_no].itemID) {
                            itemElement.querySelector('.input_item_id').setAttribute("value", response[item_no].itemID);
                            itemElement.querySelector('.input_item_id').setAttribute("name", 'input_item_id_' + response[item_no].next_key);
                        }
                        if (response[item_no].price) {

                            let data = {
                                countryCode: "D",
                                itemNo: resolvedItemNo,
                            };

                            const price = response[item_no].price;
                            const tempEl = document.createElement('span');
                            tempEl.innerHTML = price;
                            const displayPrice = GLOBALS.priceToFloat(tempEl.textContent.trim()) === 0
                                ? GLOBALS.tc.request_price
                                : price;
                            let sendData = JSON.stringify(data);
                            calculateForItemNo(sendData).then((response) => {
                                let depositHtml = "";
                                const depositCost = response.depositCost;
                                if (depositCost) {
                                    const formatPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                                        style: 'currency',
                                        currency: document.body.dataset.defaultCurrency
                                    }).format(depositCost);
                                    depositHtml = "+ " + formatPrice + " " + GLOBALS.tc.deposit_costs;
                                }
                                itemElement.querySelector('.js-include-prices').innerHTML = displayPrice + "<span class=\"directOrderDepositCosts\">" + depositHtml + "</span>";
                            });

                        }
                        if (response[item_no].inventory) {
                            itemElement.querySelector('.js-include-inventory').innerHTML = response[item_no].inventory;
                        }
                        if (response[item_no].orderbutton) {
                            itemElement.querySelector('.js-include-addon').innerHTML = response[item_no].orderbutton;
                        }

                        const fetchResponse = await FetchService.get('/em/itemReference/getAltItemNoForCustomer/' + resolvedItemNo);
                        if (fetchResponse.success) {
                            const newItemno = fetchResponse.data;
                            itemElement.querySelector('.directOrderItemlistItem__info').innerHTML = `<small class="directOrderItemlistItem__itemNo">${newItemno}</small><br/><a href="${response[item_no].item_link}" class="directOrderItemlistItem__description">${response[item_no].description}</a>`;
                        }

                        window.scrollTo({
                            top: document.getElementById('activDirectOrder').getBoundingClientRect().top + window.pageYOffset - document.getElementById('header').offsetHeight,
                            behavior: "smooth"
                        });

                        if (response[item_no].emptybox) {
                            itemElement.insertAdjacentHTML(
                                'afterend',
                                response[item_no].emptybox
                            );
                        }

                        itemElement.classList.remove("directOrderItemlistItem--empty");
                        itemElement.setAttribute("id", "");
                        const directOrderInputSubmit = document.getElementById('bt_item_no_input_direct_order');
                        directOrderInputSubmit.addEventListener('keyup', function (ItemInputEvent) {
                            var InputValue = directOrderInputSubmit.value;
                            if (InputValue.length > 0) {
                                if (ItemInputEvent.key === "Enter") {
                                    ItemInputEvent.preventDefault();
                                    ItemInputEvent.stopPropagation();
                                    ItemInputEvent.stopImmediatePropagation();

                                    enterSubmitInput(directOrderInputSubmit);
                                }
                            }
                        });
                        const directOrderInputSubmitButton = document.getElementById('js-bt-direct-order-submit-button')

                        if (directOrderInputSubmitButton) {
                            directOrderInputSubmitButton.addEventListener('click', function (e) {
                                var InputValue = directOrderInputSubmit.value;
                                if (InputValue.length > 0) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();
                                    enterSubmitInput(directOrderInputSubmit);
                                }
                            });
                        }
                        if (!response[item_no].show) {
                            document.getElementById('bt_item_no_input_direct_order').focus();
                        } else {
                            if (!response[item_no].available) {
                                itemElement.querySelector('.js_quantity_input').disabled = true;
                                itemElement.querySelector('.quantity').classList.add("quantity--inactive");
                            }
                            itemElement.querySelector('.js_quantity_input').focus();
                            itemElement.querySelector('.js_quantity_input').select();
                        }
                    } else {
                        showDirectorderMessage();
                    }
                }
            }

            updateItemlistStickyOrderBarCount();
            setNewTabindexes();
            externalStock();
        }
    }).catch(function (err){
        console.error(err);
        addErrorClass(input.closest(".inputGroup"));
    });
}

function enterSubmitInput(input){
    hideDirectorderMessageMaximum();
    hideDirectorderMessage();
    addLoadingClass(input.closest(".inputGroup"));

    if(document.querySelectorAll('.directOrderItemlistItem').length >= 500){
        showDirectorderMessageMaximum();
    }else{
        updateInputDirectorder(input);
    }
}

function hideDirectorderMessage(){
    const directOrderMessageMaximum = document.getElementById("directOrderMessage");
    if(directOrderMessageMaximum){
        directOrderMessageMaximum.classList.add("hidden");
    }
}

function showDirectorderMessage(){
    const directOrderMessageMaximum = document.getElementById("directOrderMessage");
    if(directOrderMessageMaximum){
        directOrderMessageMaximum.classList.remove("hidden");
    }
}

function hideDirectorderMessageMaximum(){
    const directOrderMessageMaximum = document.getElementById("directOrderMessageMaximum");
    if(directOrderMessageMaximum){
        directOrderMessageMaximum.classList.add("hidden");
    }
}

function showDirectorderMessageMaximum(){
    const directOrderMessageMaximum = document.getElementById("directOrderMessageMaximum");
    if(directOrderMessageMaximum){
        directOrderMessageMaximum.classList.remove("hidden");
    }
}

function setNewTabindexes(){
    let count = 10000;
    let qtyInputs = getAllQuantityInputs(document.querySelector(".directOrderList"));
    const directOrderInputSubmit = document.getElementById('bt_item_no_input_direct_order');

    if(qtyInputs){
        for(let quantityInput of qtyInputs){
            quantityInput.tabIndex = count;
            count++;
        }
    }

    if(directOrderInputSubmit){
        directOrderInputSubmit.tabIndex = count+1;
    }
}

export function beturboDirectOrder(){
    const directOrderInputSubmit = document.getElementById('bt_item_no_input_direct_order'),
        directOrderInputSubmitButton = document.getElementById('js-bt-direct-order-submit-button');

    if(!directOrderInputSubmit){
        return;
    }

    function focusOnInput() {
        directOrderInputSubmit.focus();
    }

    focusOnInput();

    directOrderInputSubmit.addEventListener('keydown', function (ItemInputEvent) {
        var InputValue = directOrderInputSubmit.value;
        if (InputValue.length > 0) {
            if (ItemInputEvent.key === "Enter") {
                ItemInputEvent.preventDefault();
                ItemInputEvent.stopPropagation();
                ItemInputEvent.stopImmediatePropagation();

                enterSubmitInput(directOrderInputSubmit);
            }
        }
    });

    if(directOrderInputSubmitButton){
        directOrderInputSubmitButton.addEventListener('click', function (e) {
            var InputValue = directOrderInputSubmit.value;
            if (InputValue.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                enterSubmitInput(directOrderInputSubmit);
            }
        });
    }

    loadDepositCostsOnInit();

    document.querySelector('.js-addListItemToBasketAll').addEventListener('click', function () {
        setTimeout(function (){
            removeAllAction();
            focusOnInput();
        },200);
    });

    document.addEventListener("click",function (e){
        if(e.target.classList.contains("js-removeFromDirectOrder")){
            removeFromDirectOrderAction(e.target);
        }
    });
}

function removeAllAction() {
    resetDirectOrder();
    XhrService.generalAjaxCall('deleteAllDirectOrderItemListItem', {
        "sid": SESSION_ID,
    }, 'POST', 'json').then(response => {
        if (response) {
        }
    });
}

function resetDirectOrder(){
    hideDirectorderMessageMaximum();
    for(let item of document.querySelectorAll('.directOrderItemlistItem:not(.directOrderItemlistItem--empty):not(.directOrderItemlistItem--header)')){
        item.remove();
    }
    const activDirectOrder = document.getElementById("activDirectOrder");
    if(activDirectOrder){
        activDirectOrder.setAttribute("data-id-row",0);
    }
    updateItemlistStickyOrderBarCount();
}

function removeFromDirectOrderAction(target) {
    hideDirectorderMessageMaximum();
    let deleteRow = target.closest(".directOrderItemlistItem");
    XhrService.generalAjaxCall('deleteDirectOrderItemListItem', {
        "sid": SESSION_ID,
        "item_list": [deleteRow.getAttribute("data-id-row")]
    }, 'POST', 'json').then(response => {
        if (response) {
            const response_item_key = Object.keys(response);
            for (const item_no of response_item_key) {
                if(response[item_no].action){
                    deleteRow.remove();
                    let rows = document.querySelectorAll('.directOrderItemlistItem:not(.directOrderItemlistItem--empty):not(.directOrderItemlistItem--header)');
                    if(rows.length === 0){
                        resetDirectOrder();
                    }
                }
            }
        }
    });
}

function loadDepositCostsOnInit() {
    const elements = document.querySelectorAll(".directOrderItemlistItem[data-id]");
    for(let element of elements) {
        const itemNo = element.dataset.itemno;
        const itemPrice = element.dataset.price;

        let data = {
            countryCode : "D",
            itemNo : itemNo,
        };

        let sendData = JSON.stringify(data);
        calculateForItemNo(sendData).then((response) => {
            let depositHtml = "";
            const depositCost = response.depositCost;
            if(depositCost) {
                const formatPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                    style: 'currency',
                    currency: document.body.dataset.defaultCurrency
                }).format(depositCost);
                depositHtml =  "+ " + formatPrice + " " + GLOBALS.tc.deposit_costs;
            }
            element.querySelector('.directOrderDepositCosts').innerHTML = depositHtml;
        });
    }

    replaceItemno();
    externalStock();
}